import { addLastPrefixDE } from '../transforms/addLastPrefix';
import { formatOrdinalDE } from '../transforms/formatOrdinal';
import { overrideBaseLocale } from './base-config';
export var deDE = overrideBaseLocale('de-DE', {
    dayOfMonthOrdinal: {
        options: {
            day: 'numeric',
        },
        transforms: [formatOrdinalDE],
    },
    lastDayOfWeekLong: {
        options: {
            weekday: 'long',
        },
        transforms: [addLastPrefixDE],
    },
});
//# sourceMappingURL=de-DE.js.map